"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[468],{

/***/ 97441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eo": function() { return /* binding */ cookDiscoveryFilter; },
/* harmony export */   "Ot": function() { return /* binding */ transformBlock; },
/* harmony export */   "Zj": function() { return /* binding */ getBlockDomId; },
/* harmony export */   "jx": function() { return /* binding */ convertObjectDiscoveryToQueryStringSearch; },
/* harmony export */   "yA": function() { return /* binding */ findBlockByType; }
/* harmony export */ });
/* unused harmony exports transformBlockItemTypeSku, transformBanner, transformBlockMixBanner, transformBlockHotDeal, transformBlockListingTab, isDefaultBlock, getBodyDiscoveryDefaultBlock, fetchSingleDataBlockSSR, fetchDataBlockSSR */
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89172);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20577);
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93512);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28247);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31260);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






const listingAndDiscoveryKeysMap = {
    priceGte: "price_gte",
    priceLte: "price_lte"
};
const listingAndDiscoveryValuesMap = {
    ORDER_BY_DESCENDING: "DESC",
    ORDER_BY_ASCENDING: "ASC"
};
const convertObjectDiscoveryToQueryStringSearch = (params)=>{
    if (!params) return "/";
    const newParams = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .cleanObject */ .sW)(_objectSpreadProps(_objectSpread({}, params), {
        router: "productListing"
    }));
    return "/search?" + Object.keys(newParams).map((key)=>{
        if (!newParams[key] || Array.isArray(newParams === null || newParams === void 0 ? void 0 : newParams[key]) && newParams[key].length === 0) {
            return;
        }
        return (listingAndDiscoveryKeysMap[key] || key) + "=" + (listingAndDiscoveryValuesMap[newParams[key]] || newParams[key]);
    }).filter((query)=>query).join("&");
};
const cookDiscoveryFilter = (filter)=>{
    if (!filter) return {};
    if (filter === null || filter === void 0 ? void 0 : filter.attributes.length) {
        filter.attributes.map((el)=>filter["attributes.".concat(el.code)] = el.optionIds.join());
        const { attributes: tbr  } = filter, newFilter = _objectWithoutProperties(filter, [
            "attributes"
        ]);
        return newFilter;
    }
    return filter;
};
const findBlockByType = (type, blocks)=>{
    return blocks && blocks.find((block)=>block.type === type);
};
const getUrl = (item)=>{
    var ref;
    const { url , redirectUrl , params  } = item || {};
    return redirectUrl ? redirectUrl : url || convertObjectDiscoveryToQueryStringSearch(_objectSpread({}, cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter), ((ref = item.params) === null || ref === void 0 ? void 0 : ref.sorting) || {}));
};
const getLinkHref = (url, paramsObject, title)=>{
    let href = null;
    if (url) {
        if (url.startsWith("/landing/")) {
            href = {
                pathname: "/landing/[id]",
                query: {
                    id: url.substring("/landing/".length)
                }
            };
        } else {
            href = url;
        }
    } else {
        // remove non-relevant flags from paramsObject
        // such as false param or empty array
        // we don't want them to appear on browser url
        /**
     * 
     *  "sellingCodes": [],
        "priceLte": "0",
        "priceGte": "0",
        "brands": [],
        "flashSaleType": "",
        "masterCategories": [],
        "excludedSkus": [],
        "masterCategoryIds": [62],
      }
     */ const queryParams = {};
        for (const [key, value] of Object.entries(paramsObject)){
            if (value && (!Array.isArray(value) || value.length > 0) && (isNaN(value) || !!parseInt(value))) {
                queryParams[key] = value;
            }
        }
        href = {
            pathname: "/search",
            query: _objectSpreadProps(_objectSpread({}, queryParams), {
                pageTitle: title,
                router: "productListing"
            })
        };
    }
    return {
        href
    };
};
const transformBlockItemTypeSku = (block)=>{
    const { fetchParams , collectionSlug =""  } = block.content;
    block.cookedData = {
        queryString: convertObjectDiscoveryToQueryStringSearch(_objectSpread({}, cookDiscoveryFilter(fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.filter), fetchParams.sorting)),
        paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .cleanObject */ .sW)({
            filter: collectionSlug ? undefined : cookDiscoveryFilter(fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.filter),
            sorting: collectionSlug ? {} : (fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.sorting) || {},
            slug: collectionSlug,
            blockId: block.id
        })
    };
    return block;
};
const transformBanner = (block)=>{
    const banners = block.content.items.map((item)=>{
        var ref, ref1;
        const paramsObject = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .cleanObject */ .sW)(_objectSpreadProps(_objectSpread({}, cookDiscoveryFilter(item === null || item === void 0 ? void 0 : (ref = item.params) === null || ref === void 0 ? void 0 : ref.filter), ((ref1 = item.params) === null || ref1 === void 0 ? void 0 : ref1.sorting) || {}), {
            blockId: block.id,
            itemId: item.id
        }));
        return {
            id: item.id,
            targetPath: getUrl(item),
            image: item.imageUrl,
            campaignName: item.label,
            description: item.subLabel,
            paramsObject,
            url: item.url,
            thumbnail: item.thumbnail,
            link: getLinkHref(item.url || item.redirectUrl, paramsObject, item.label),
            imageSize: item.imageSize
        };
    });
    block.cookedData = banners || [];
    return block;
};
const transformBlockMixBanner = (block)=>{
    var ref, ref1;
    const firstItem = block === null || block === void 0 ? void 0 : (ref = block.content) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1[0];
    const trackingRegionName = "categoriesBlockBrand";
    block.cookedData = {
        header: {
            title: block.label,
            link: {
                href: getUrl(firstItem)
            }
        },
        banner: {
            src: firstItem.imageUrl,
            alt: firstItem.label || firstItem.subLabel,
            tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O)({
                isTrackContent: true,
                regionName: trackingRegionName,
                contentName: firstItem.label,
                target: getUrl(firstItem)
            }),
            link: {
                href: getUrl(firstItem)
            }
        },
        contentItems: block.content.items.slice(1, 5).map((category)=>({
                name: category.label,
                description: category.subLabel,
                image: {
                    src: category.imageUrl,
                    alt: category.label || category.subLabel
                },
                link: {
                    href: getUrl(category)
                }
            })),
        bottomImages: block.content.items.slice(5, 11).map((brand, index)=>({
                src: brand.imageUrl,
                alt: brand.label || brand.subLabel,
                tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O)({
                    isTrackContent: true,
                    regionName: trackingRegionName,
                    contentName: brand.label,
                    index,
                    target: getUrl(brand)
                }),
                link: {
                    href: getUrl(brand)
                }
            }))
    };
    return block;
};
const transformBlockHotDeal = (block)=>{
    block.cookedData = block.content.items.map((el)=>{
        const { collectionSlug , params , id  } = el;
        return _objectSpreadProps(_objectSpread({}, el), {
            name: el.label,
            url: el.redirectUrl || el.url,
            paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .cleanObject */ .sW)({
                filter: collectionSlug ? undefined : cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter),
                sorting: collectionSlug ? {} : (params === null || params === void 0 ? void 0 : params.sorting) || {},
                slug: collectionSlug,
                blockId: block.id,
                itemId: id
            })
        });
    });
    return block;
};
const transformBlockListingTab = (block)=>{
    const categoryList = [];
    block.content.items.forEach((item)=>{
        const { collectionSlug , params , id  } = item;
        const obj = _objectSpreadProps(_objectSpread({}, item), {
            id: item.id,
            name: item.label,
            paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__/* .cleanObject */ .sW)({
                filter: collectionSlug ? undefined : cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter),
                sorting: collectionSlug ? {} : (params === null || params === void 0 ? void 0 : params.sorting) || {},
                slug: collectionSlug,
                blockId: block.id,
                itemId: id
            })
        });
        categoryList.push(obj);
    });
    block.cookedData = categoryList;
    return block;
};
const transformBlock = (block)=>{
    if (block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockItemType.SKU */ .Nc.SKU) return transformBlockItemTypeSku(block);
    else if (block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockItemType.BANNER */ .Nc.BANNER || [
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.HORIZONTAL_HIGHLIGHTED_BANNER */ .kH.HORIZONTAL_HIGHLIGHTED_BANNER,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.RECOMMENDED_CATEGORY */ .kH.RECOMMENDED_CATEGORY,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.RECOMMENDED_BRANDS */ .kH.RECOMMENDED_BRANDS,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.PROMOTE_CATEGORY_MENU */ .kH.PROMOTE_CATEGORY_MENU,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.HORIZONTAL_2_BANNER_MOBILE */ .kH.HORIZONTAL_2_BANNER_MOBILE, 
    ].includes(block.type)) return transformBanner(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.MIX_BANNER */ .kH.MIX_BANNER) return transformBlockMixBanner(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.COUNT_DOWN_PROMO_BIG_SKU */ .kH.COUNT_DOWN_PROMO_BIG_SKU || block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.COUNT_DOWN_PROMO_TAB_MOBILE */ .kH.COUNT_DOWN_PROMO_TAB_MOBILE) return transformBlockHotDeal(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.LISTING_TAB */ .kH.LISTING_TAB) return transformBlockListingTab(block);
    else return block;
};
const isDefaultBlock = (blocks, device)=>{
    const mainSkuList = findBlockByType(device === "desktop" ? BlockType.MAIN_SKU_LIST : BlockType.LIST_SKU_MOBILE, blocks);
    return blocks.length === 2 && !!mainSkuList;
};
const getBodyDiscoveryDefaultBlock = (blocks, device)=>{
    if (!isDefaultBlock(blocks, device)) return null;
    const mainSkuList = findBlockByType(device === "desktop" ? BlockType.MAIN_SKU_LIST : BlockType.LIST_SKU_MOBILE, blocks);
    const fetchParams = _objectSpreadProps(_objectSpread({}, mainSkuList.content.fetchParams), {
        blockId: mainSkuList.id
    });
    const filterParams = _objectSpreadProps(_objectSpread({}, fetchParams.filter, fetchParams.sorting), {
        blockId: mainSkuList.id
    });
    return cleanObject(filterParams);
};
const fetchSingleDataBlockSSR = async function(context, block) {
    let includeFilter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref;
    const { discoveryService  } = new ServiceContainer(context.req.tenantEnv);
    const filterParams = block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : ref.paramsObject;
    const variables = _objectSpreadProps(_objectSpread({}, cleanObject(filterParams)), {
        terminalCode: context.req.tenantEnv.terminal,
        location: context.req.location
    });
    try {
        var ref1, ref2;
        const [{ result  }, { result: resultFilter  }] = await Promise.all([
            discoveryService.search(_objectSpreadProps(_objectSpread({}, variables, cleanObject(context.query)), {
                itemsPerPage: context.req.isMobile ? 10 : 40
            })),
            includeFilter ? await discoveryService.search(_objectSpreadProps(_objectSpread({}, variables), {
                itemsPerPage: 1,
                returnFilterable: [
                    "FILTER_TYPE_BRAND",
                    "FILTER_TYPE_PRICE",
                    "FILTER_TYPE_ATTRIBUTE",
                    "FILTER_TYPE_CLEARANCE", 
                ]
            })) : {
                result: null
            }, 
        ]);
        return {
            products: (result === null || result === void 0 ? void 0 : result.products) || [],
            filters: (resultFilter === null || resultFilter === void 0 ? void 0 : resultFilter.filter) ? cookFilter(resultFilter === null || resultFilter === void 0 ? void 0 : resultFilter.filter, normalizePageBuilderToDiscoveryParams(variables), resultFilter === null || resultFilter === void 0 ? void 0 : resultFilter.masterCategories) : null,
            filterPrice: {
                max: Number(resultFilter === null || resultFilter === void 0 ? void 0 : (ref1 = resultFilter.filter) === null || ref1 === void 0 ? void 0 : ref1.priceLte),
                min: Number(resultFilter === null || resultFilter === void 0 ? void 0 : (ref2 = resultFilter.filter) === null || ref2 === void 0 ? void 0 : ref2.priceGte)
            }
        };
    } catch (error) {
        logger.error(error);
        return {
            products: []
        };
    }
};
const fetchDataBlockSSR = async (context, blocks)=>{
    const simpleProductBlocks = blocks.filter((b)=>[
            BlockType.FLASH_SALE,
            BlockType.PROMOTE_SELLER,
            BlockType.BEST_SELLING_PRODUCT,
            BlockType.LIST_SKU_MOBILE,
            BlockType.MAIN_SKU_LIST,
            BlockType.COUNT_DOWN_PROMO_SKU,
            BlockType.HORIZONTAL_SKU_LIST, 
        ].includes(b.type) && b.itemType === BlockItemType.SKU);
    const partialRenderedBlocks = blocks.filter((b)=>[
            BlockType.COUNT_DOWN_PROMO_TAB_MOBILE,
            BlockType.COUNT_DOWN_PROMO_BIG_SKU,
            BlockType.LISTING_TAB, 
        ].includes(b.type));
    const { discoveryService  } = new ServiceContainer(context.req.tenantEnv);
    const mapProducts = await Promise.all([
        ...simpleProductBlocks.map(async (block)=>{
            const result = await fetchSingleDataBlockSSR(context, block);
            return {
                [block.id]: (result === null || result === void 0 ? void 0 : result.products) || []
            };
        }),
        ...partialRenderedBlocks.map(async (block)=>{
            var ref;
            // paramObject contant: blockId, itemId and other filter of discovery
            const firstItem = block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : ref[0];
            const blockId = block === null || block === void 0 ? void 0 : block.id;
            const itemId = firstItem === null || firstItem === void 0 ? void 0 : firstItem.id;
            const paramsObject = firstItem === null || firstItem === void 0 ? void 0 : firstItem.paramsObject;
            if (!paramsObject || !blockId || !itemId) return;
            const products = await discoveryService.search(_objectSpreadProps(_objectSpread({}, paramsObject), {
                terminalCode: context.req.tenantEnv.terminal,
                itemsPerPage: 20,
                location: context.req.location
            })).then((res)=>{
                var ref;
                return (res === null || res === void 0 ? void 0 : (ref = res.result) === null || ref === void 0 ? void 0 : ref.products) || [];
            }).catch((error)=>{
                logger.error(error);
                return [];
            });
            return {
                ["".concat(blockId, "_").concat(itemId)]: products
            };
        }), 
    ]);
    return mapProducts.filter(Boolean).reduce((acc, curr)=>_objectSpread({}, acc, curr), {});
};
const getBlockDomId = (block)=>block.label ? (0,_teko_slug__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(block.label) : "".concat(block.name, "-").concat(block.id);


/***/ }),

/***/ 30468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uD": function() { return /* binding */ useDiscovery_useDiscoveryProduct; },
  "b9": function() { return /* binding */ useDiscovery_useDiscoverySearch; },
  "fz": function() { return /* binding */ useDiscovery_useInfiniteDiscoverySearch; },
  "yz": function() { return /* binding */ useDiscovery_usePersonalizeBlocks; },
  "lR": function() { return /* binding */ useRecommendationComboDetail; },
  "jG": function() { return /* binding */ useRecommendationCombosData; },
  "mF": function() { return /* binding */ useRecommendationProductsData; },
  "TA": function() { return /* binding */ useDiscovery_useSkus; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-63a52198c3/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(93369);
// EXTERNAL MODULE: ./helpers/block.ts
var block = __webpack_require__(97441);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(84443);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(43015);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-63a52198c3/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/infinite/dist/index.esm.js
var dist_index_esm = __webpack_require__(62176);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js
var index_es = __webpack_require__(31260);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/helpers.es.js
var helpers_es = __webpack_require__(41713);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/types.es.js
var types_es = __webpack_require__(89172);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-43024fe1e9/1/packages/discovery/dist/hooks.es.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useDiscoverySearch = (discoveryService, params, location, options) => {
  const _a = params || {}, searchParams = __objRest(_a, ["sorting"]);
  const keyAPI = (0,helpers_es/* getKeyAPI */.jG)(params, discoveryService.getBaseUrl());
  const normalizedParams = (0,helpers_es/* normalizePageBuilderToDiscoveryParams */.nS)(searchParams);
  const { data, error } = (0,index_esm/* default */.ZP)(keyAPI, async () => {
    const { sellerIds } = params;
    let newSellerIds = sellerIds;
    if (Array.isArray(sellerIds) && typeof sellerIds[0] === "number") {
      newSellerIds = sellerIds.map((id) => id.toString());
    }
    return await discoveryService.search(__spreadProps(__spreadValues({}, params), {
      sellerIds: newSellerIds,
      location
    }));
  }, __spreadProps(__spreadValues({}, options), {
    revalidateOnFocus: false
  }));
  const result = data == null ? void 0 : data.result;
  return {
    result: {
      products: (result == null ? void 0 : result.products) || [],
      filter: (result == null ? void 0 : result.filter) || {},
      pagination: (data == null ? void 0 : data.pagination) || {},
      cookedFilters: (0,helpers_es/* cookFilter */.BR)(result == null ? void 0 : result.filter, normalizedParams, result == null ? void 0 : result.masterCategories),
      searchIntents: (0,helpers_es/* cookSearchIntent */.WG)(result) || void 0,
      suggestedKeyword: result == null ? void 0 : result.suggestedKeyword
    },
    isLoading: !params ? false : !error && !data,
    isError: error
  };
};
const useInfiniteDiscoverySearch = (discoveryService, params, options) => {
  const getKey = (pageIndex) => {
    const _a = params, rest = __objRest(_a, ["page"]);
    return [rest, pageIndex];
  };
  const convertSearchResponse = (response) => {
    return {
      products: (response == null ? void 0 : response.products) || [],
      searchIntents: (0,helpers_es/* cookSearchIntent */.WG)(response),
      suggestedKeyword: response == null ? void 0 : response.suggestedKeyword
    };
  };
  const { data, isValidating, size, setSize } = (0,dist_index_esm/* default */.ZP)(getKey, async (_params, index) => {
    const { result } = await discoveryService.search(__spreadProps(__spreadValues({}, params), {
      page: parseInt(params.page || "1") + index
    }));
    return convertSearchResponse(result);
  }, options);
  const isEmpty = data && data[0].products.length === 0;
  const hasMore = !(isEmpty || data && data[data.length - 1] && data[data.length - 1].products.length < (params.itemsPerPage || 10));
  const products = data ? data.reduce((acc, curr) => {
    return [...acc, ...curr.products];
  }, []) : [];
  const cookedData = data == null ? void 0 : data[0];
  return {
    isEmpty: !!isEmpty,
    isLoading: isValidating,
    hasMore,
    size,
    setSize,
    products,
    searchIntents: (cookedData == null ? void 0 : cookedData.searchIntents) ? cookedData.searchIntents : null,
    suggestedKeyword: cookedData == null ? void 0 : cookedData.suggestedKeyword
  };
};
const useDiscoveryProduct = (discoveryService, sku, terminal, location) => {
  const { data, error } = useSWR(!!sku && !!terminal ? [`${discoveryService.getBaseUrl}/product`, sku, terminal, location] : null, async (_, sku2, terminal2, location2) => {
    return await discoveryService.getProduct({
      sku: sku2,
      terminalCode: terminal2,
      location: location2
    });
  });
  return {
    result: {
      product: data || null
    },
    isLoading: !error && !data,
    isError: !!error
  };
};
const usePersonalizeBlocks = (discoveryService, blockParams, terminal, transformBlock) => {
  var _a, _b;
  const { pageTypeEnum, category, seller, brand, sellerCategory } = blockParams;
  const params = (0,index_es/* cleanObject */.sW)(__spreadValues({
    terminalCode: terminal
  }, blockParams));
  const conditionFetching = terminal && (pageTypeEnum === types_es/* PageTypeEnum.HOME */.DZ.HOME || types_es/* PageTypeEnum.NOTIFICATION */.DZ.NOTIFICATION || pageTypeEnum === types_es/* PageTypeEnum.CATEGORY */.DZ.CATEGORY && (category || sellerCategory) || pageTypeEnum === types_es/* PageTypeEnum.BRAND */.DZ.BRAND && brand || pageTypeEnum === types_es/* PageTypeEnum.SELLER */.DZ.SELLER && seller);
  const { data, error } = (0,index_esm/* default */.ZP)(conditionFetching ? [`${discoveryService.getBaseUrl}/blocks`, JSON.stringify(params)] : null, async (_, paramsJson) => {
    return await discoveryService.getBlock(JSON.parse(paramsJson));
  });
  return {
    result: (((_a = data == null ? void 0 : data.result) == null ? void 0 : _a.blocks) || []).map(transformBlock),
    seoInfo: ((_b = data == null ? void 0 : data.result) == null ? void 0 : _b.seoInfo) || {},
    isLoading: !error && !data,
    isError: error
  };
};
const useSkus = (discoveryService, skus, terminal, location) => {
  const { data, error } = (0,index_esm/* default */.ZP)(skus ? [
    `${discoveryService.getBaseUrl}/products`,
    skus.join(","),
    terminal,
    location
  ] : null, async (_, skus2, terminal2, location2) => {
    return await discoveryService.getProductDetailBySkus({
      skus: skus2,
      terminalCode: terminal2,
      location: location2
    });
  });
  return {
    result: {
      products: data || []
    },
    isLoading: !skus ? false : !error && !data,
    isError: error
  };
};



;// CONCATENATED MODULE: ./hooks/useDiscovery.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




const checkAlcoholicProduct = (product)=>{
    var ref, ref1;
    if (!product) return product;
    let sellerCatCodes = [];
    const categories = (product === null || product === void 0 ? void 0 : (ref = product.productInfo) === null || ref === void 0 ? void 0 : ref.categories) || [];
    const masterCategories = (product === null || product === void 0 ? void 0 : (ref1 = product.productInfo) === null || ref1 === void 0 ? void 0 : ref1.masterCategories) || [];
    sellerCatCodes = categories.concat(masterCategories);
    return _objectSpreadProps(_objectSpread({}, product), {
        isAlcoholicCategory: sellerCatCodes.some((item)=>item.isAdult)
    });
};
const useDiscovery_useDiscoverySearch = (params, options)=>{
    var ref;
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService , discoveryPos365Service  } = (0,ServiceContext/* useServices */.Su)();
    const _ref = useDiscoverySearch((params === null || params === void 0 ? void 0 : params.pos365StoreCode) ? discoveryPos365Service : discoveryService, params, location, options), { result  } = _ref, rest = _objectWithoutProperties(_ref, [
        "result"
    ]);
    return _objectSpread({
        result: _objectSpreadProps(_objectSpread({}, result), {
            products: result === null || result === void 0 ? void 0 : (ref = result.products) === null || ref === void 0 ? void 0 : ref.map(checkAlcoholicProduct)
        })
    }, rest);
};
const useDiscovery_useInfiniteDiscoverySearch = (params, options)=>{
    const { discoveryService , discoveryPos365Service  } = (0,ServiceContext/* useServices */.Su)();
    const _ref = useInfiniteDiscoverySearch((params === null || params === void 0 ? void 0 : params.pos365StoreCode) ? discoveryPos365Service : discoveryService, params, options), { products  } = _ref, rest = _objectWithoutProperties(_ref, [
        "products"
    ]);
    return _objectSpread({
        products: products === null || products === void 0 ? void 0 : products.map(checkAlcoholicProduct)
    }, rest);
};
const useDiscovery_useDiscoveryProduct = (sku, productId, options)=>{
    const { terminal , location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const { data: product , mutate , error , isValidating: isLoading ,  } = (0,index_esm/* default */.ZP)(!!sku && !!terminal ? [
        sku,
        terminal,
        location,
        productId
    ] : null, async (sku, terminal, location, productId)=>{
        const params = {
            productId,
            sku,
            terminalCode: terminal,
            location
        };
        return discoveryService.getProduct(params);
    }, _objectSpreadProps(_objectSpread({}, options), {
        revalidateOnFocus: false
    }));
    return {
        result: {
            product: product && checkAlcoholicProduct(product)
        },
        isLoading,
        isError: !!error,
        mutate
    };
};
const useDiscovery_usePersonalizeBlocks = (blockParams)=>{
    const { terminal  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    return usePersonalizeBlocks(discoveryService, blockParams, terminal, block/* transformBlock */.Ot);
};
const useDiscovery_useSkus = (skus)=>{
    const { terminal , location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    return useSkus(discoveryService, skus, terminal, location);
};
const useRecommendationProductsData = (sku)=>{
    var ref;
    const { terminal  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const { data , error  } = (0,index_esm/* default */.ZP)(!!sku && !!terminal ? [
        "".concat(discoveryService.getBaseUrl, "/products_recommendation"),
        sku,
        terminal, 
    ] : null, async (_, sku, terminal)=>{
        return await discoveryService.getRecommendationProducts(sku, terminal);
    }, {
        revalidateOnFocus: false
    });
    return {
        result: {
            productSets: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.productSets) || []
        },
        isLoading: !error && !data,
        isError: error
    };
};
const useRecommendationCombosData = (sku)=>{
    var ref;
    const { terminal , location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const { data , error  } = (0,index_esm/* default */.ZP)(!!sku && !!terminal ? [
        "".concat(discoveryService.getBaseUrl, "/products_combo"),
        sku,
        terminal,
        location, 
    ] : null, async (_, sku, terminal, location)=>{
        return await discoveryService.getRecommendationCombos(sku, {
            terminalCode: terminal,
            location
        });
    }, {
        revalidateOnFocus: false
    });
    return {
        result: {
            combos: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.combos) || []
        },
        isLoading: !error && !data,
        isError: error
    };
};
const useRecommendationComboDetail = function(payloadCombo) {
    let call = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { terminal , location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const skus = ((payloadCombo === null || payloadCombo === void 0 ? void 0 : payloadCombo.comboLineItems) || []).map((el)=>el.sku);
    const { data , error  } = (0,index_esm/* default */.ZP)(payloadCombo && call ? [
        "".concat(discoveryService.getBaseUrl, "/detail-combo"),
        JSON.stringify(_objectSpreadProps(_objectSpread({}, payloadCombo), {
            terminalCode: terminal,
            location
        })), 
    ] : null, (_)=>{
        return discoveryService.getDetailComboRecommendation(_objectSpreadProps(_objectSpread({}, payloadCombo), {
            terminalCode: terminal,
            location
        })).then((res)=>{
            var ref;
            return res === null || res === void 0 ? void 0 : (ref = res.result) === null || ref === void 0 ? void 0 : ref.combo;
        });
    }, {
        revalidateOnFocus: false
    });
    const reorderProductInCombo = ()=>{
        const { products  } = data;
        const newProducts = skus.map((el)=>{
            const product = products.find((p)=>p.product.productInfo.sku === el);
            return product;
        });
        return _objectSpreadProps(_objectSpread({}, data), {
            products: newProducts
        });
    };
    return {
        result: {
            combo: data ? reorderProductInCombo() : null
        },
        isLoading: !error && !data,
        isError: error
    };
};


/***/ })

}]);